import React, {Component} from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import apiBarcode from "../../../services/api/apiBarcode"
import {pushNewItemHistory} from "../../../services/api/apiItemHistory"
import printQR from "../actions/printQR"
import ItemDetail from "./ItemDetail"


class OrderItemDetail extends Component {
    state = {
        order: {},
        loading: false,
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {barcode, time} = prevProps
        const {barcode: currentBarcode, time: currentTime} = this.props

        if (barcode.code !== currentBarcode.code || currentTime !== time) {
            console.log('Change code:', currentBarcode.code)

            return this._fetchOrderDetail()
        }
    }

    _addHistory = () => {
        const {code} = this.props.barcode

        return pushNewItemHistory(code, {
            event_key: 'scan_to_print_qr',
            event_description: 'Scan QR to print QR code.'
        })
    }

    _requestPrintQR = () => {
        const {order} = this.state
        const {index} = this.props.barcode

        return printQR(order, index)
    }

    _handleAfterFetchDetail = async () => {
        this._addHistory()
        await this._requestPrintQR()

        return this.props.onComplete()
    }

    _fetchOrderDetail = async () => {
        const {barcode} = this.props

        console.log('Fetching order:', barcode)
        const {number} = barcode
        if (!number) return false

        if (this.state.loading) return true
        this.setState({
            loading: true,
        })

        try {
            const {data: response} = await apiBarcode.getBarcodeByNumber(number)
            const {success, data, message} = response

            if (!success) {
                throw new Error(message)
            }

            this.setState({
                order: data,
                loading: false,
            }, this._handleAfterFetchDetail)
        } catch (e) {
            window.alert(e.message)

            this.setState({
                loading: false,
                order: {},
            })
        }

    }

    render() {
        const {barcode} = this.props
        const {code, index} = Object.assign({}, barcode)

        if (!code) return null

        const {order, loading} = this.state

        return (
            <div className={classNames("OrderItemDetail", {loading})}>
                <ItemDetail order={order} index={index}/>
            </div>
        )
    }
}

OrderItemDetail.propTypes = {
    time: PropTypes.any,
    barcode: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
}

export default OrderItemDetail
